import React from 'react';
import { TouchableOpacity, Text, StyleSheet, Alert, Platform } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { processLoginAccount } from '../utils/Functions';
import UserState from '../src/contexts/UserState';
import Storage from './Storage';
import { useLinkTo } from '@react-navigation/native';
import * as WebBrowser from 'expo-web-browser';
import * as Google from 'expo-auth-session/providers/google';
import { ResponseType } from 'expo-auth-session';

WebBrowser.maybeCompleteAuthSession();

export default function GoogleAuthButton(props) {
  const [user, setUser] = React.useContext(UserState);
  const linkTo = useLinkTo();

  const [request, response, promptAsync] = Google.useAuthRequest({
    expoClientId: '71260036337-6aritahpv5nl8uvcpsid2446cc35p5hj.apps.googleusercontent.com',
    iosClientId: '71260036337-tj19fnhm2lgqgr5bua73qao88mvgecnu.apps.googleusercontent.com',
    androidClientId: '71260036337-g2cukeetiu1qdcsptshrkmhqq09p3pqb.apps.googleusercontent.com',
    webClientId: '71260036337-gnnljhapan8soh8332j71ur6juobcbav.apps.googleusercontent.com',
    responseType: ResponseType.IdToken,
  });

  const googleIcon = <FontAwesome name="google" size={16} color="white" />;

  React.useEffect(() => {
    if(Platform.OS === 'android'){
      WebBrowser.warmUpAsync();
      return () => {
        WebBrowser.coolDownAsync();
      };
    }
  }, []);

  React.useEffect(() => {
    console.log('useEffect response: ', response);
    if (response?.type === 'success') {
      const { params } = response;
      console.log('params: ', params);
      getGoogleUserInfo(params.id_token);
    }
  }, [response]);

  const getGoogleUserInfo = async (idToken) => {
    fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${idToken}`)
    .then(resp => resp.json())
    .then(user => {
      loginWithGoogle(user, idToken);
    })
  }

  const loginWithGoogle = async (user, idToken) => {
    try {
      if (props.setLoginType) {
        props.setLoginType('Google');
      }
      console.log('idToken: ', idToken);
      console.log('user: ', user);

      let googleUser = {
        email: user.email,
        name: user.name,
        avatar: user.picture,
        type: 'Google',
        id: user.sub,
        idToken: idToken,
      };
      props.setSocialUser(googleUser);
      console.log('googleUser', googleUser);
      try {
        let apiLoginResult = await props.socialApiLogin(googleUser, 'google');
        console.log('apiLoginResult', apiLoginResult);
        if (apiLoginResult.result) {
          let user = processLoginAccount(apiLoginResult.session.account, true);
          checkUsernameSecureStore(user, googleUser);
          // props.setUser(user);
          // prop.setLoggedIn(true);
        } else {
          if (apiLoginResult.MFA) {
            props.setShowMFA(true);
            props.setMFARequired(true);
          } else {
            if (apiLoginResult.errors) {
              console.log(apiLoginResult.errors.join('; '));
            }
            props.navigation.navigate('SignUp', { socialUser: googleUser });
          }
        }
      } catch (err) {
        Alert.alert('Error', err);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const checkUsernameSecureStore = async (user, socialUser) => {
    // const delU = SecureStore.deleteItemAsync('username');
    // const delP = SecureStore.deleteItemAsync('password');
    // const setA = SecureStore.setItemAsync('useLocalAuthentication', 'no');
    const socialId = await Storage.getItem('socialId');
    console.log('checkUsernameSecureStore', socialId);
    if (!socialId || (socialId !== socialUser.id)) {
      console.log('deleting useLocalAuthentication');
      await Storage.removeItem('useLocalAuthentication');
    }

    console.log('social checkUserNameSecureStore: ', user, socialUser);
    const setS = Storage.setItem('username', socialUser.id);
    const delU = Storage.removeItem('socialId');
    const delP = Storage.removeItem('password');
    await Promise.all([setS, delU, delP])

    setUser(user);

    if (!user.terms_of_use) {
      linkTo('/acceptterms?signUp=yes');
    }

    return true;
  }

  return (
    <TouchableOpacity style={styles.button} onPress={() => { promptAsync(); }} activeOpacity={0.6}>
      <FontAwesome name="google" size={16} color="white" />
      <Text style={styles.text}>Sign in with Google</Text>
    </TouchableOpacity>
  );

}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    padding: 10,
    backgroundColor: '#4285F4'
  },
  text: {
    color: 'white',
    marginLeft: 5,
    fontSize: 18,
    fontWeight: '500',
  }
})